<template>
  <div class="ac1000-meter" :class="styleMap[state]"></div>
</template>

<script>
export default {
  props: {
    state: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      styleMap: ['l0', 'l1', 'l2']
    };
  }
};
</script>

<style lang="scss" scoped>
.ac1000-meter {
  width: 300px;
  height: 32px;
  &.l0 {
    background-image: linear-gradient(
      to right,
      #34eb18 33.3%,
      #687188 33.3% 66.6%,
      #63488c 66.6% 100%
    );
  }
  &.l1 {
    background-image: linear-gradient(
      to right,
      #3e7388 33.3%,
      #f8e816 33.3% 66.6%,
      #63468d 66.6% 100%
    );
  }
  &.l2 {
    background-image: linear-gradient(
      to right,
      #3e7388 33.3%,
      #687289 33.3% 66.6%,
      #e0122d 66.6% 100%
    );
  }
}
</style>
